import { render, staticRenderFns } from "./mrptranssrorder.vue?vue&type=template&id=8b966a04&scoped=true&"
import script from "./mrptranssrorder.vue?vue&type=script&lang=js&"
export * from "./mrptranssrorder.vue?vue&type=script&lang=js&"
import style0 from "./mrptranssrorder.vue?vue&type=style&index=0&id=8b966a04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b966a04",
  null
  
)

export default component.exports